import React, { useEffect, useState } from "react";
import { leaveApi } from "../../services/leaveApi";
import { StatusBadge } from "../../components/StatusBadge";
import { PageHelpBanner } from "../../components/PageHelpBanner";
import { useLocalization } from "../../hooks/useLocalization";

export default function MyMandatoryLeavePage() {
  const { t } = useLocalization();
  const [rows, setRows] = useState([]);

  useEffect(() => { leaveApi.myMandatoryUse().then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="my-mandatory-leave-page">
      <PageHelpBanner pageKey="my-mandatory-leave" title={t("pageHelp.defaultTitle")}>
        <p>{t("pageHelp.myMandatoryLeave")}</p>
      </PageHelpBanner>
      <div>
        <h2 className="text-xl font-bold tracking-tight text-gray-900">{t("myMandatoryLeave.title")}</h2>
        <p className="text-sm text-gray-500">{t("myMandatoryLeave.subtitle")}</p>
      </div>

      {rows.length === 0 && (
        <div className="bg-white border border-gray-200 rounded-xl p-6 text-center text-sm text-gray-500" data-testid="no-mandatory-leave-rows">
          {t("myMandatoryLeave.noRequirement")}
        </div>
      )}

      {rows.map((r) => (
        <div key={r.grant_id} className="bg-white border border-gray-200 rounded-xl p-5 space-y-3" data-testid={`my-mandatory-leave-card-${r.grant_id}`}>
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-gray-800">{t("myMandatoryLeave.grantDated", { date: r.grant_date })}</p>
            <StatusBadge status={r.status} />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <p><span className="text-gray-500">{t("myMandatoryLeave.required")}:</span> {r.required_use_total} {t("myMandatoryLeave.days")}</p>
            <p><span className="text-gray-500">{t("myMandatoryLeave.used")}:</span> {r.used_amount} {t("myMandatoryLeave.days")}</p>
            <p><span className="text-gray-500">{t("myMandatoryLeave.planned")}:</span> {r.planned_approved_leave} {t("myMandatoryLeave.days")}</p>
            <p><span className="text-gray-500">{t("myMandatoryLeave.remaining")}:</span> <span className="font-bold">{r.remaining_mandatory_amount} {t("myMandatoryLeave.days")}</span></p>
          </div>
          <p className="text-xs text-gray-500">{t("myMandatoryLeave.deadline")}: {r.monitoring_end}{r.days_remaining_in_window != null && ` (${r.days_remaining_in_window} ${t("myMandatoryLeave.daysLeft")})`}</p>
        </div>
      ))}
    </div>
  );
}
